import { Line } from '@trukt/types/Line';
import { PaginatedQueryParams } from '@trukt/types/PaginatedQueryParams';
import { PaginatedResults } from '@trukt/types/PaginatedResults';
import { Charge } from '@trukt/portal-utils/Charge';
import { AxiosInstance } from 'axios';

export type InvoiceLineItemsSearchRequest = PaginatedQueryParams;
type InvoiceLineItemsSearchResponse = PaginatedResults<{ id: string; name: Line['name'] }>;

type InvoiceLineItemsBaseLinesBody = {
  lines: Charge['guid'][];
};

interface InvoiceLineItemsExportRequest extends InvoiceLineItemsBaseLinesBody {}
interface InvoiceLineItemsReleaseRequest extends InvoiceLineItemsBaseLinesBody {}

type InvoiceLineItemsExportResponse = void;
type InvoiceLineItemsReleaseResponse = void;

export class LineService {
  instance: AxiosInstance;
  constructor(instance: AxiosInstance) {
    this.instance = instance;
  }

  search(request?: InvoiceLineItemsSearchRequest) {
    return this.instance.get<InvoiceLineItemsSearchResponse>('/invoice-line-items', {
      params: request,
    });
  }

  export(request: InvoiceLineItemsExportRequest) {
    return this.instance.put<InvoiceLineItemsExportResponse>(
      '/invoice-lines/export',
      request.lines,
    );
  }

  release(request: InvoiceLineItemsReleaseRequest) {
    return this.instance.put<InvoiceLineItemsReleaseResponse>(
      '/invoice-lines/payment-release',
      request.lines,
    );
  }
}
